import React, { useState, useEffect, useMemo } from "react"
import Flink from '~/components/shared/flink'
import { useSwipeable } from 'react-swipeable'
import { useTheme } from '~/contexts/ThemeContext'
import { useCart } from '~/contexts/CartContext'
import { usePdp } from '~/contexts/PdpContext'
import { imgSize } from '~/utils/helpers'
import useAnalytics from '~/utils/analytics'
import PdpInit from '~/initializers/pdp-init'

import { IconChevLeft, IconChevRight } from '~/components/icons/chevrons'

import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/pdp/outfit.module.scss"


const Outfit = ({ is_pdp=true }) => {
  const { gender, isTouches, setFreeze, analytics, setAnalytics } = useTheme()
  const { setCartOpen } = useCart()
  const { getOutfits } = PdpInit()
  const { product } = usePdp()
  const { outfits, outfills } = product
  const prod_gender = product.gender

  const { elev_select, ga_tile_click } = useAnalytics()

  const products = useMemo(() => getOutfits({outfits, outfills, prod_gender, gender}), [])
  const [pos, setPos] = useState(0)

  const out_img = (prod) => {
    let img = prod.image
    return img ? imgSize(img,400) : false
  }

  // const get_color = (outfit) => {
  //   const id = outfit.shop_id
  //   const colors = outfit.product_line.colors.standard.concat(outfit.product_line.colors.venice_wash)
  //   const color = colors.find(x => x.shop_id === id)
  //   return color ? color.name : false
  // }

  const handleLink = (outfit,index) => {
    const tile_ind = 0
    const list = is_pdp ? 'wear it with' : 'cart recommendation'

    setCartOpen(false)
    setAnalytics({...analytics, list: list})
    ga_tile_click(outfit, tile_ind, list)
    elev_select(outfit, tile_ind, list)
    setFreeze(false)
  }

  const handleClick = (num) => {
    const change = pos + (num * 2)
    setPos(change)
  }

  const swipers = useSwipeable({
    onSwiping: (e) => {
      if (!isTouches || outfits.length < 3) return
    },
    onSwipedLeft: (e) => {
      if (!isTouches || outfits.length < 3) return
      handleClick(1)
    },
    onSwipedRight: (e) => {
      if (!isTouches || outfits.length < 3) return
      handleClick(-1)
    },
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: true,
    delta: {
      up: 1000,
      down: 1000,
    },
  })
  
  const checkShow = (index) => {
    return (pos === 0 ? index > 1 : index < 2).toString()
  }

  return (
    <>
      <div className={`${styles.outfit_wr} ${is_pdp ? '' : styles.cart}`} outfwr=''>
        <div className={styles.head}>
          <div className={styles.outfit_title}>
            {prod_gender === 'u' ? 'Looks Good' : 'Wear it'} With
          </div>
          {products.length > 2 && (
            <div className={styles.arrows} outf-arrs=''>
              <button 
                type="button"
                className={`${aria_btn} ${styles.more} ${pos !== 0 ? '' : styles.off}`} 
                disabled={pos !== 0 ? undefined : 'disabled'}
                onClick={(e)=>{handleClick(-1)}}
                aria-label='Previous recommendations'
              >
                <IconChevLeft icon_classes="" />
              </button>
              <button 
                type="button"
                className={`${aria_btn} ${styles.more} ${(pos === 2) ? styles.off : ''}`}
                disabled={pos === 2 ? 'disabled' : undefined}
                onClick={(e)=>{handleClick(1)}}
                aria-label='Next recommendations'
              >
                <IconChevRight icon_classes="" />
              </button>
            </div>
          )}
        </div>
        <div className={styles.outfits} {...swipers} outfs=''>
          {products.map( (outfit,index) => 
            <div 
              key={`outf-${outfit.handle}`} 
              className={styles.outfit}
              aria-hidden={checkShow(index)} 
              outf=''
            >
              {out_img(outfit) && (
                <div className={styles.image}>
                  <Flink 
                    href={`/products/${outfit.handle}`}
                    onClick={(e)=> handleLink(outfit,index) }
                  >
                    <img 
                      src={out_img(outfit)} alt={`Buy it with ${outfit.title}`} 
                      width={200}
                      height={270}
                    />
                  </Flink>
                </div>
              )}
              <div className={styles.out_text}>
                <Flink 
                  href={`/products/${outfit.handle}`} 
                  className={styles.title}
                  onClick={(e)=> handleLink(outfit,index) }
                  outf-titl=''
                >
                  {outfit.title}
                </Flink>
                <div className={styles.price} outf-pr=''>${outfit.first_product_price}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default Outfit
